import React, {useEffect, useState} from 'react'
import { fetchChains } from "../../../../../modules/chains";

export default function SecondaryChainSelect({ className, secondary_chain_id, chain_id, updateField }) {
  const [chains, setChains] = useState([]);

  useEffect(() => {
    fetchChains({parent_id: chain_id})
      .then((data) => {
        setChains(data);
      })
  }, [])

  return (
    <select
      id="chain"
      name="chain"
      value={secondary_chain_id}
      className={className}
      onChange={(e) => {
        updateField('secondary_chain_id', e.target.value);
      }}
    >
      <option value="" selected disabled>Select a Chain</option>
      { chains.map((chain, index) => (
        <option key={`chain-${chain.id}`} value={chain.id}>
          {chain.name}
        </option>
      ))}
    </select>
  )
}
